import React, { useRef, useEffect, useState, useMemo } from 'react';
import { Range } from 'rc-slider';

const RangeSlider = ({ range, setRange, minOdd, maxOdd, autoBetData }) => {
  const ref = useRef(null);
  const [prevRange, setPrevRange] = useState([]);
  const [isTouchEnd, setIsTouchEnd] = useState(false);

  const { isAutoBet, autoBetCount } = autoBetData;

  // eslint-disable-next-line consistent-return
  const currentEvent = useMemo(() => {
    if (window.MouseEvent) return 'mousedown';
    if (window.PointerEvent) return 'pointerdown';
  }, []);

  const checkWhichSideActive = (slider_1, slider_2) => {
    if (slider_1.classList.contains('rc-slider-handle-dragging')) {
      return slider_1;
    }
    if (slider_2.classList.contains('rc-slider-handle-dragging')) {
      return slider_2;
    }
    return null;
  };

  const handleRangeChange = ([min, max]) => {
    if (prevRange?.length) {
      setRange(prevRange);
    } else if (!isTouchEnd) {
      const [currentMin] = range;
      min = min < minOdd ? minOdd : min;
      max = max > maxOdd ? maxOdd : max;
      setRange([min, max]);

      if (min === minOdd && max === maxOdd) {
        setRange(currentMin === min ? [minOdd + 1, max] : [min, maxOdd - 1]);
      } else {
        setRange([min, max]);
      }
    }
  };

  useEffect(() => {
    const handleDoubleClick = (e) => {
      const reactProps = Object.keys(e?.target)?.find((key) => key?.includes('__reactProps')); // FOR PRODUCTION
      const reactEventHandlers = Object.keys(e?.target)?.find((key) =>
        key?.includes('__reactEventHandlers')
      ); // FOR DEVELOPMENT
      const val = e?.target?.[reactProps || reactEventHandlers]?.['aria-valuenow'];
      if (val) {
        setRange([val, val]);
      }
    };

    const slider = ref?.current;
    slider?.sliderRef && slider.sliderRef.addEventListener('dblclick', handleDoubleClick);
    return () =>
      slider?.sliderRef && slider.sliderRef.removeEventListener('dblclick', handleDoubleClick);
  }, []); // eslint-disable-line

  useEffect(() => {
    const handleMouseLeave = () => {
      setPrevRange(range);
      const slider_1 = document.querySelector('.rc-slider-handle-1');
      const slider_2 = document.querySelector('.rc-slider-handle-2');
      if (checkWhichSideActive(slider_1, slider_2)) {
        checkWhichSideActive(slider_1, slider_2)?.classList?.remove('rc-slider-handle-dragging');
      }
    };

    const handlePointerEvent = () => setPrevRange([]);
    document.documentElement.addEventListener('mouseleave', handleMouseLeave);
    document.addEventListener(currentEvent, handlePointerEvent);

    return () => {
      document.documentElement.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener(currentEvent, handlePointerEvent);
    };
  }, [range]);

  useEffect(() => {
    const slider = ref?.current;
    slider?.sliderRef &&
      slider.sliderRef.addEventListener('touchstart', () => {
        setIsTouchEnd(false);
      });
    slider?.sliderRef &&
      slider.sliderRef.addEventListener('touchend', () => {
        setIsTouchEnd(true);
      });

    return () => {
      slider?.sliderRef &&
        slider.sliderRef.removeEventListener('touchstart', () => {
          setIsTouchEnd(false);
        });
      slider?.sliderRef &&
        slider.sliderRef.removeEventListener('touchend', () => {
          setIsTouchEnd(false);
        });
    };
  }, [range]);

  return (
    <div
      className={`striker-g-range-wrp ${
        !isAutoBet || (isAutoBet && !autoBetCount) ? '' : 'passive'
      }`}
    >
      <p className='striker-g-range-num-block'>{1}</p>
      <div className='striker-g-range-block'>
        <Range
          ref={ref}
          step={1}
          min={minOdd}
          max={maxOdd}
          value={range}
          vertical={false}
          tabIndex={[null, null]}
          draggableTrack
          onChange={handleRangeChange}
          appearance='minimal'
        />
      </div>
      <p className='striker-g-range-num-block'>{100}</p>
    </div>
  );
};

export default RangeSlider;
